module.exports = __webpack_public_path__ + "static/media/NZ.6bb1f1bd.svg";